import {
  AccordionDetails,
  Accordion as MUIAccordion,
  AccordionSummary,
  styled,
  AccordionProps as MUIAccordionProps,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { memo } from "react";

interface AccordionProps {
  title: string | JSX.Element;
  children?: React.ReactNode;
  accordionProps?: Partial<MUIAccordionProps>
}
const Accordion = memo((props: AccordionProps) => {
  const { title, children, accordionProps: accordianProps } = props;

  return (
    <StyledAccordion {...accordianProps} >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1-content"
        id="panel1-header"
      >
        {title}
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </StyledAccordion>
  );
});


const StyledAccordion = styled(MUIAccordion)(({ theme: { palette } }) => ({
  color: palette.theme?.secondary[1000],
  fontSize: " 0.875rem",
  boxShadow: "none",
  ".MuiAccordionSummary-root": {
    padding: "0.625rem 1.5rem",
    minHeight: "0px !important",
    borderBottomWidth: "2px",
    borderBottomStyle: "solid",
    borderBottomColor: palette.theme?.secondary[200],
  },
  ".MuiAccordionSummary-content": {
    margin: "0",
    "&.Mui-expanded": {
      margin: "0rem",
    },
    "&.MuiButtonBase-root": {
      margin: "0",
      "&.MuiAccordionSummary-content.Mui-expanded": {
        margin: "0",
      },
    },
  },
  ".MuiAccordionDetails-root": {
    padding: "0",
  },
}));

export { Accordion };
export default Accordion;
